import {registerNav} from '../../components/common/di-ding'
import {routeNameOfDi} from './common'

const nav = [
  {
    icon: 'el-icon-damai-shujulaiyuan',
    name: '概览',
    permissionCode: '',
    to: {
      routeName: 'access-over-view',
      also: {
        routeName: []
      }
    }
  },
  {
    icon: 'el-icon-damai-shebeiguanli',
    name: '设备管理',
    permissionCode: '003001000',
    to: {
      routeName: 'accessCtrlDeviceManagementCenter',
      also: {
        routeName: ['add-device', 'modify-device', 'current-device']
      }
    }
  },
  {
    icon: 'el-icon-damai-menjinshouquan',
    permissionCode: '003002000',
    name: '授权管理',
    sub: [{
      name: '二维码门禁',
      permissionCode: '003002000',
      to: {
        diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_EMPOWERMENT,
        also: {
          diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_EMPOWERMENT_ENTERPRISE,
        }
      }
    }, {
      name: '人脸门禁',
      permissionCode: '003002000',
      to: {
        diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_FACE_AUTHORITY,
        also: {
          diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_FACE_AUTHORITY_ENTERPRISE,
        }
      }
    }, {
      name: '门禁一体机',
      permissionCode: '003002000',
      to: {
        diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_KEYPAD_INTEGRATION,
        also: {
          diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_KEYPAD_INTEGRATION_ENTERPRISE,
        }
      }
    },
    {
      name: '授权记录',
      permissionCode: '003002000',
      to: {
        diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_FACE_ISSUE,
      }
    }]
  },
  {
    icon: 'el-icon-damai-kaimenjilu',
    permissionCode: '003003000',
    name: '开门记录',
    to: {
      diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_OPEN_RECORD
    }
  },
  {
    icon: 'el-icon-damai-menjinbaojing',
    permissionCode: '003004000',
    name: '报警记录',
    to: {
      diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_CALL_POLICE
    }
  },
  {
    icon: 'el-icon-damai-zhuangtairizhi',
    permissionCode: '003005000',
    name: '状态日志',
    to: {
      diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_DEVICE_STATUS
    }
  },
  {
    icon: 'el-icon-damai-config',
    permissionCode: '003006000',
    name: '开门计划',
    to: {
      diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_OPEN_CONFIG,
    }
  },
  {
    icon: 'el-icon-damai-ic_caozuorizhi',
    permissionCode: '003007000',
    name: '操作日志',
    to: {
      routeName: 'access-ctrl-log'
    }
  }
]

registerNav(nav)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/nav.js